/**
 * Route paths only - deliberately free of component imports so anything can reference a path
 * without pulling in the whole route tree. `baseRoutes.tsx` re-exports this for existing callers.
 */
export const baseRoutes = {
  login: "/login",
  home: "/",
  // User
  user: "/user",
  userAccount: "/user/account",
  userProfile: "/user/profile",
  userProfileList: "/user/profile/profile-list",
  userProfileHandler: "/user/profile/profile-handler/:id",
  userProfileSync: "/user/profile/profile-sync",
  userAppointment: "/user/appointment",
  userAppointmentList: "/user/appointment/appointment-list",
  userAppointmentDetail: "/user/appointment/appointment-detail/:key",
  userPrescription: "/user/prescription",
  userPrescriptionList: "/user/prescription/prescription-list",
  userPrescriptionDetail: "/user/prescription/prescription-detail/:code",
  userPackage: "/user/package",
  userPackageList: "/user/package/package-list",
  userPackageDetail: "/user/package/package-detail/:key",
  userPackageBooking: "/user/package/package-booking/:key",
  userPromotion: "/user/promotion",
  userExamination: "/user/examination",
  userChronic: "/user/chronic",
  userInsurance: "/user/insurance",
  userPayment: "/user/payment",
  userPaymentList: "/user/payment/payment-list",
  userPaymentDetail: "/user/payment/payment-detail/:key",
  userChangePassword: "/user/change-password",
  partner: "/partner",
  medicalInfo: "/news",
  search: "/search",
  orderFacility: "/danh-muc",
  doctor: "/doctor",
  specialist: "/specialist",
  policyActivation: "/kich-hoat-the-bao-hiem",
  bookingAppointment: "/bookingAppointment",
  bookingOnline: "/bookingOnline",
  bookingPackage: "/bookingPackage",
  paymentPackageService: "/paymentPackageService",
  medicine: "/medicine",
  orderResult: "/order/results",
  aboutUS: "/gioi-thieu",
  privacy: "/gioi-thieu/dieu-khoan-chinh-sach-bao-mat",
  achievementsAndAwards: "/thanh-tuu-giai-thuong",
  paymentTerms: "/gioi-thieu/dieu-khoan-chinh-sach-bao-mat#quy-trinh-giao-dich",
  product: "san-pham",
};
